import { ProjectData } from '@backoffice-monorepo/api';

export class PlPiProjectData extends ProjectData {
  projectName = 'NetCard Pl';
}
